//= Functions & Modules
// Others
import React from 'react';

//= Structures & Data
// Own
import { URLs } from '../data/URLs';
import { PermissionsContext } from '../modules/permissions';

//= React components
// Own
import { Menu, MenuOption } from '../modules/menu';
import { faRobot, faCode, faCoins, faList, faFlask } from '@fortawesome/free-solid-svg-icons';

type Props = {
    inDialog?: boolean;
    className?: string;
};

export default class AppMenu extends React.PureComponent<Props> {
    static contextType = PermissionsContext;
    context!: React.ContextType<typeof PermissionsContext>;

    render() {
        return (
            <Menu {...this.props}>
                <MenuOption label="Bots" href={URLs.BOTS} icon={faRobot} />
                <MenuOption label="Program Maker" href={URLs.PROGRAM_MAKER} icon={faCode} />
                <MenuOption label="Binance Accounts" href={URLs.BINANCE_ACCOUNTS} icon={faCoins} />
                <MenuOption label="Trading Programs" href={URLs.TRADING_PROGRAMS} icon={faList} />
                {this.context.includes('see_simulate') && (
                    <MenuOption label="Simulate" href={URLs.SIMULATE} icon={faFlask} />
                )}
            </Menu>
        );
    }
}
